import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "l-the-side-menu" }
const _hoisted_2 = { class: "p-the-side-menu" }
const _hoisted_3 = {
  key: 0,
  class: "p-the-side-menu__links"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheCategoryList = _resolveComponent("TheCategoryList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.isShowCat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "p-the-side-menu__label" }, "商品カテゴリー", -1)),
            _createVNode(_component_TheCategoryList, {
              categories: _ctx.categories,
              link: _ctx.link,
              class: "p-the-side-menu__category-list",
              onClickSubcategory: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickOnSubcategory($event)))
            }, null, 8, ["categories", "link"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}